import { render, staticRenderFns } from "./EventContestEntryFormStep2.vue?vue&type=template&id=dba17ee4"
import script from "./EventContestEntryFormStep2.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventContestEntryFormStep2.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dba17ee4')) {
      api.createRecord('dba17ee4', component.options)
    } else {
      api.reload('dba17ee4', component.options)
    }
    module.hot.accept("./EventContestEntryFormStep2.vue?vue&type=template&id=dba17ee4", function () {
      api.rerender('dba17ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestEntryFormStep2.vue"
export default component.exports